import { NetworkStatus } from '@cbridge-utils/network';
import { ICoverageAccountStore } from './coverageAccount.interface';

export const coverageAccountInitialState: ICoverageAccountStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
